import infoIcon from "../assets/exclamation-mark.svg";
import React, { useEffect, useState } from "react";

export default function ShakyInfoBox({
  children,
  autoHideDuration = null,
  onHide,
}) {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (autoHideDuration) {
      const timer = setTimeout(() => {
        setIsVisible(false);
        if (onHide) onHide();
      }, autoHideDuration);

      return () => clearTimeout(timer);
    }
  }, [autoHideDuration, onHide]);

  if (!isVisible) return null;

  return (
    <div className={"shaky-infobox shake-box-animation"}>
      <img src={infoIcon} alt="Information box" />
      <div>{children}</div>
    </div>
  );
}
